// import React, {useEffect, useMemo, useRef, useState} from 'react';
import { getAuth } from 'firebase/auth';
import { buildTree, flattenTreeAll } from './Tree/utilities.ts';
import { v4 as uuid } from 'uuid';
// import { TreeItem, TreeItems } from './Tree/types.ts';

function ImportExportDataPanel(  {items,
                                  setItems}  ) {

    // const [inputStartText, setInputStartText] = useState('');

    function handleImportClick(e) { 
      
      e.preventDefault();
  
      // Read the form data
      // const form = e.target;
      // const formData = new FormData(form);

      // Or you can work with it as a plain object:
      // const formJson = Object.fromEntries(formData.entries());
      console.log('Doing import stuff...');

      
      
      // let cumulativeItemCountString;
      // console.log('Cumulative item count as parsed: '+cumulativeItemCount);
      // if(isNaN(cumulativeItemCount))
      // {
      //   cumulativeItemCountString = "0";
      // }
      // else {
      //   cumulativeItemCountString = cumulativeItemCount;
      // }
      // const newItem = [{id: "Task #"+cumulativeItemCountString+" : "+formJson.taskTitle, children: []}];
      // setInputStartText('');



      //TODO: Load and parse in  file.

      // TODO: Will need to set item counter if importing and a counter is found
      //localStorage.setItem("itemCount", cumulativeItemCountString+1);

      // if(items) {
        //TODO: Set items from file if importing.
        // const newItems = newItem.concat(items);
        // setItems(newItems);
      
        // const dbOpenRequest = window.indexedDB.open("TasksDB",1);

        // let db;

        // let objectStore;

        // dbOpenRequest.onerror = (event) => {
        //   console.error(`Database error: ${event.target.error?.message}`);
        //   alert("Issue connecting to DB!!");
        // };

        // dbOpenRequest.onsuccess = (event) => {
        //   db = event.target.result;
        //   console.log('DB connection opened for updating!!');

        // // This assumes the objectStore has already been successfully created in the DB
        // // TODO: handle the exception if not.
        // const objectStore = db
        //   .transaction("TaskNestedLists", "readwrite")
        //   .objectStore("TaskNestedLists");
          
        //   console.log('Got object store on button clicked!! '+ objectStore);
        //   const storedItems = event.target.result;
        //   console.log('Items obtained from DB: '+storedItems);
        //   const requestUpdate = objectStore.put(newItems,1);
        //   requestUpdate.onsuccess = (event) => {
        //     // Success - the data is updated!
        //   };

        // };

        // dbOpenRequest.onupgradeneeded = (event) => {
        //   db = event.target.result;
        //   alert("DB was upgraded!!");  
          
        //   const objectStore = db
        //   .transaction("TaskNestedLists", "readwrite")
        //   .objectStore("TaskNestedLists");

        //   objectStore.put(newItems, 1);

        // };

    // }

    var input = document.createElement('input');
    input.type = 'file';

    input.onchange = e => { 

      // getting a hold of the file reference
      var file = e.target.files[0]; 

      // setting up the reader
      var reader = new FileReader();
      reader.readAsText(file,'UTF-8');

      // here we tell the reader what to do when it's done reading...
      reader.onload = readerEvent => {
          var content = readerEvent.target.result; // this is the content!
          console.log( content );
          const cumulativeItemCount = parseInt(content.split('\n')[0]);
          console.log('Cumulative item count as parsed from file: '+cumulativeItemCount);

          //TODO All kinds of null checks needed here!!!
          if(cumulativeItemCount &&(cumulativeItemCount > parseInt(localStorage.getItem("itemCount")))) {
            console.log('Setting local storage Cumulative item count to: '+cumulativeItemCount);
            localStorage.setItem("itemCount", cumulativeItemCount);
          }
          
          var loadedItems = JSON.parse(content.split('\n').slice(1).join('\n'), reviver);
          console.log( loadedItems);

          //TODO: This is effective in ensuring valid data but quite inefficient...
          setItems(buildTree(flattenTreeAll(enforceIDs(loadedItems))));
      }
    }
    
    input.click();
    
  }

  const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/;
  const dateFormatWithMilliseconds = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/;

  function reviver(key, value) {
    if (typeof value === "string" && (dateFormat.test(value)||dateFormatWithMilliseconds.test(value))) {
      return new Date(value);
    }

    return value;
  }

  function enforceIDs(
    items
    ) {
    for (const item of items) {
      console.log("Processing an imported task... ID: " + item.id);
      if(!item.id || item.id === null || item.id === '' ) {
        console.log("Imported task ID data incomplete... Current ID: "+item.id);
        item.id = uuid();
        console.log("Newly generated ID: " + item.id);
      }

      item.ownerId = getAuth().currentUser?.uid;
  
      if (item.children.length) {
        item.children = enforceIDs(item.children);
      }
    }
  
    return [...items];
  }

  function handleExportClick(e) { 
      
    e.preventDefault();

    console.log('Doing export stuff...');
    
    const cumulativeItemCount = parseInt(localStorage.getItem("itemCount"));
    console.log('Cumulative item count as parsed: '+cumulativeItemCount);
  
    if(items) {
      console.log(JSON.stringify(items, null, 2));

      function downloadTextFile(text, name) {
        const a = document.createElement('a');
        const type = name.split(".").pop();
        a.href = URL.createObjectURL( new Blob([text], { type:`text/${type === "txt" ? "plain" : type}` }) );
        a.download = name;
        a.click();
      }
      // TODO:: Call flattenItems() here to ensure indexation of 'items'
      //        such that each item has an 'index' property set to a valid 
      //        index to record canonical items order for export.
      // TODO:: Implement a more elegant solution for storing canoncial/user 
      //        order of items in the item tree.
      const dataString = JSON.stringify(items, null, 2); 
      downloadTextFile(cumulativeItemCount+'\n'+dataString, 'My TAOIS data.json');
  }
}

  return(
    <>
      <form padding="25xp" method="post" onSubmit={handleImportClick}>
        <button type="submit">Import Data...</button>
      </form>
      <form padding="25xp" method="post" onSubmit={handleExportClick}>
        <button type="submit">Export Data...</button>
      </form>
    </>
    
  );

}

export default ImportExportDataPanel;